import { TextButton } from '@creditornot/cb-button';
import { colors, typographyCss } from '@creditornot/cb-ingredients';
import { Toast as CookbookToast } from '@creditornot/cb-toast';
import { ToastVariant } from '@creditornot/cb-toast';
import React from 'react';
import toast, { Renderable } from 'react-hot-toast';
import styled from 'styled-components';

export const StyledToast = styled(CookbookToast)`
  width: 400px;
`;

export const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  /* adjust react-hot-toast inner message div to look good with cb-toast */
  > div {
    display: block;
    margin: 0;
  }

  gap: 5px;
`;

const ActionContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: flex-end;
`;

const ActionLink = styled(TextButton)`
  ${typographyCss.Body3};
  font-weight: 500;
  margin-block-start: 8px;
  margin-inline-end: 16px;
  color: ${colors.wolt100};

  &:hover {
    color: ${colors.wolt92};
  }
`;

type Props = {
  variant: ToastVariant;
  title: string;
  message?: Renderable;
  toastId: string;
  linkText?: string;
  onLinkClick?: () => void;
};

export const CustomToast = ({ variant, title, message, toastId, linkText, onLinkClick }: Props) => (
  <StyledToast variant={variant} title={title} onCloseButtonClick={() => toast.dismiss(toastId)}>
    {!!message && (
      <MessageContainer>
        <p>{message}</p>
      </MessageContainer>
    )}
    {!!linkText && !!onLinkClick && (
      <ActionContainer>
        <ActionLink onClick={onLinkClick}>{linkText}</ActionLink>
      </ActionContainer>
    )}
  </StyledToast>
);
